<template>
    <div class="modal fade Betamount" id="userid_Modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>{{$t('user-id', 'User ID')}}</h5>
                    <button type="button" class="btn-close" aria-label="Close" @click="closeUserId($auth?.user?.userid)"></button>
                </div>
                <div class="modal-body">
                    <div class="userid-celebration-img">
                        <img src="@/assets/images/user-id.webp" alt="user-id">
                    </div>
                    <div class="modal-userid-sec">
                        <div class="c_text">
                            <div class="flex_between copy-user-text-sec">
                                <h5 class="payment_op">{{ $auth?.user?.userid }}</h5>
                                <button class="copy_btn" @click="copyRefUrl($auth?.user?.userid)" type="button">
                                    <!-- <img src="@/assets/images/c_text.svg" alt="copy" />  -->
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { copyUserIdRefUrl,closeUserId } from '@template/utils'
import { mapGetters } from 'vuex';
export default {
    name: 'UserIdModal',
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters(['logInData']),
    },
    methods: {
        copyRefUrl(referData) {
            copyUserIdRefUrl(referData)
        },
        closeUserId(userId) {
            closeUserId(this,userId)
            this.$helper.closeModal("userid_Modal");
            if(this.$siteSettings?.data.offer?.image) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$helper.openModal("#offer_pop_up");
                    }, 500)
                })
            }            
        }
    }
}
</script>

<style>

#userid_Modal .modal-header .btn-close {
    background: transparent url('@/assets/images/cross-icon.svg') center/1em auto no-repeat
}

#userid_Modal .modal-header {
    background: var(--primary-color);
}
#userid_Modal .modal-header h5 {
    color: #fff;
}

</style>